<template>
  <!-- 搜索框 -->
  <div
    ref="searchArea"
    class="search-area"
  >
    <el-input
      v-model="searchcontent"
      :placeholder="placeholder"
      class="input-with-select"
      clearable
      maxlength="56"
      size="large"
      @focus="handleFocus"
      @keydown.enter="searchblog"
    >
      <template #append>
        <el-button
          class="search-btn"
          type="primary"
          size="large"
          :disabled="isclick"
          @click="searchblog"
        >
          <span style="color: white; font-weight: 500; display: flex">搜索 </span>
        </el-button>
      </template>
    </el-input>
    <div
      v-show="isshow"
      class="search-drop-menu"
    >
      <div
        v-show="recommendations.length > 0"
        class="search-history"
      >
        <div class="search-history-list recommendations">
          <div class="search-title recommendations-title">推荐搜索</div>
          <div
            v-for="item in recommendations"
            :key="item.id"
            class="history-item"
          >
            <div @click="searchhistory(item.title)">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div
        v-show="searchhistorylist.length > 0"
        class="search-history"
      >
        <div class="search-title">
          搜索历史
          <span
            class="search-clear"
            @click="clearhistory"
          >
            <i class="ri-delete-bin-6-line"></i>
            <span>清空</span>
          </span>
        </div>
        <div class="search-history-list">
          <div
            v-for="(item, index) in searchhistorylist"
            :key="index"
            class="history-item"
            @click="searchhistory(item)"
          >
            <div>{{ item }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, nextTick } from 'vue';
import useTemplateData from '@/hooks/useTemplateData.ts';
import { getAppWordTemplatePage } from '@/request/hotspotTemplate';
// import { useStore } from 'vuex';
// import { useRoute, useRouter } from 'vue-router';

const { templateType } = useTemplateData();

const props = defineProps({
  selectedType: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['search']);

const searchArea = ref(null);
const recommendations = ref([]);
const isclick = ref(false);
const searchcontent = ref('');
const placeholder = ref('输入名称查询模板名');
const isshow = ref(false);
const searchhistorylist = ref([]);

watch(
  () => props.selectedType,
  (newVal) => {
    searchcontent.value = '';
    const list = JSON.parse(localStorage.getItem(newVal + '_search_history_list')) || [];
    searchhistorylist.value = list;
  },
  { immediate: true }
);

watch(searchcontent, (newVal, oldVal) => {
  if (timeout.value) {
    clearTimeout(timeout.value);
  }
  timeout.value = setTimeout(() => {
    getRecommendations();
  }, 500);
});

const timeout = ref(null);

onMounted(() => {
  nextTick(() => {
    document.addEventListener('click', handleClickOutside, true);
  });
});

const getRecommendations = async () => {
  isshow.value = searchcontent.value !== '';
  console.log(searchcontent.value, 'bububu');
  if (!searchcontent.value) {
    emit('search', '');
    recommendations.value = [];
    return;
  } else {
    const data = await seachTemplateDataFn();
    recommendations.value = data.list;
  }
  // Add your API calls here
};

const seachTemplateDataFn = async () => {
  let type = Array.isArray(templateType.value) && templateType.value.length ? templateType.value.join(',') : '';
  const res = await getAppWordTemplatePage({
    templateType: type,
    belong: props.selectedType,
    pageIndex: 1,
    pageSize: 5,
    keyword: searchcontent.value,
  });
  const { code, data } = res.data;
  return data;
};

const handleClickOutside = (e) => {
  if (searchArea.value && !searchArea.value.contains(e.target)) {
    isshow.value = false;
  }
};

const handleFocus = () => {
  isshow.value = searchhistorylist.value.length > 0;
};

const searchblog = () => {
  if (searchcontent.value) {
    if (searchhistorylist.value.includes(searchcontent.value)) {
      searchhistorylist.value = searchhistorylist.value.filter((item) => item !== searchcontent.value);
    }
    isshow.value = false;
    searchhistorylist.value.unshift(searchcontent.value);
    while (searchhistorylist.value.length > 10) {
      searchhistorylist.value.pop();
    }
    localStorage.setItem(props.selectedType + '_search_history_list', JSON.stringify(searchhistorylist.value));
    emit('search', searchcontent.value);
  }
};

const searchhistory = (val) => {
  isshow.value = false;
  if (searchhistorylist.value.includes(val)) {
    searchhistorylist.value = searchhistorylist.value.filter((item) => item !== val);
  }
  searchhistorylist.value.unshift(val);
  while (searchhistorylist.value.length > 10) {
    searchhistorylist.value.pop();
  }
  localStorage.setItem(props.selectedType + '_search_history_list', JSON.stringify(searchhistorylist.value));
  searchcontent.value = val;
  emit('search', searchcontent.value);
};

const clearhistory = () => {
  searchhistorylist.value = [];
  localStorage.setItem(props.selectedType + '_search_history_list', JSON.stringify(searchhistorylist.value));
  isshow.value = false;
};
</script>

<style scoped>
.input-with-select {
  max-width: 500px;
  width: 500px;
}
.search-drop-menu {
  position: sticky;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 8px 0 12px;
  font-size: 14px;
  font-weight: 400;
  -webkit-box-shadow: 0 0 10px 2px rgb(0 0 0 / 6%);
  box-shadow: 0 0 10px 2px rgb(0 0 0 / 6%);
  border-radius: 0 0 4px 4px;
  background: #1c1c1c;
  /* background: #292929; */
  /* border: 1px solid #1c1c1c; */
  color: #fff;
  top: 39px;
  left: 0;
  min-height: 200px;
  height: auto;
  text-align: left;
  z-index: 9999; /* 设置一个很高的值确保在最上层 */
}
/* .search-history {
  width: 50%;
  float: left;
}
.search-hot {
  width: 50%;
  float: left;
} */

.search-btn {
  background: linear-gradient(90deg, #5654f9 0%, #7f54f9 100%);
  border: none;
  border-radius: 0 4px 4px 0; /* Top-left, top-right, bottom-right, bottom-left */
}
.search-title {
  padding-left: 16px;
  height: 32px;
  font-size: 12px;
  color: #fc5531;
  line-height: 32px;
  position: relative;
}
.search-history-list {
  width: 100%;
  max-height: 200px;
  height: 100%;
  overflow: auto;
}

.recommendations {
  margin-bottom: 10px;
}

.recommendations-title {
  color: #409eff !important;
}
.history-item {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  display: block;
  width: 100%;
  padding: 0 16px 0 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  &:hover {
    background-color: #292929;
  }
}
.search-clear {
  right: 0px;
  color: #ccccd8;
  position: absolute;
  height: 100%;
  right: 16px;
  top: 0;
  cursor: pointer;
}
</style>
